import React from "react";

import { GenericTableColumn } from "@ui-components/Table/GenericTable";

/**
 * Interfaz de cada row devuelta por /listconfigbgpneighbor/{ctxrId}?tenantId=1
 */
export interface BgpNeighbor {
  id: number;
  ipid: string;         // "10.100.0.4"
  router_id: string;    // "1.2.3.4"
  local_address: string;
  local_as: number;
  peer_as: number;
  bgpfamily: string;    // e.g. "ipv4 mpls-vpn\nipv4 unicast"
  holdtime: number;
  typeConfig: string;   // "default"
  description: string | null;
  addPath?: number; // Optional add-path capability: 0=disabled, 1=send, 2=receive, 3=send_receive
}

/**
 * Columnas que se mostrarán en la tabla BGP:
 * - "Neighbor IP" => ipid
 * - "Local address" => local_address
 * - "Local AS" => local_as
 * - "Peer AS" => peer_as
 * - "Router ID" => router_id
 * - "Actions" (edit/delete)
 */
export const columns: GenericTableColumn<BgpNeighbor>[] = [
  {
    header: "Neighbor IP",
    accessor: "ipid",
  },
  {
    header: "Local address",
    accessor: "local_address",
  },
  {
    header: "Local AS",
    accessor: "local_as",
  },
  {
    header: "Peer AS",
    accessor: "peer_as",
  },
  {
    header: "Router ID",
    accessor: "router_id",
  },
  {
    header: "Actions",
    // accessor es requerido por la interfaz, así que
    // podemos usar "ipid" para cumplir con el tipado,
    // pero aquí la celda vendrá sobrescrita en BgpPage
    accessor: "ipid",
    renderCell: () => <div>Will be overridden in BgpPage</div>,
  },
];
